module.exports = __webpack_public_path__ + "img/parenting-exercises.e08d5547.svg";